export default __webpack_public_path__ + "static/media/azharAliabout.b66ebbf9.png";